// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const LOCATION_API_BASE_URL = new InjectionToken<string>('LOCATION_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class LocatieserverApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(LOCATION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.pdok.nl/bzk/locatieserver/search/v3_1";
    }

    /**
     * De Free API biedt de mogelijkheid om vrij te zoeken (klassiek geocoderen), waar zonder
    tussenkomst van suggesties de API direct resultaten teruggeeft op basis van de zoekopdracht.
     * @param q (optional) Hiermee worden de zoektermen opgegeven. De Solr-syntax voor zoektermen kan hier
    worden toegepast, bijv. combineren met "and", en het gebruik van dubbele quotes
    voor opeenvolgende zoektermen. Zoektermen mogen incompleet zijn. Ook wordt er
    gebruik gemaakt van synoniemen.

    Voorbeelden:
    `q=Utrecht`: geeft resultaten terug met de zoekterm Utrecht, bijv. adressen in
    de stad Utrecht, woonplaatsen en gemeenten in de provincie Utrecht.

    `q="De Bilt"`: geeft resultaten terug met de zoekterm De Bilt, bijv. de
    woonplaats en gemeente De Bilt, of adressen in deze woonplaats. Let op
    dat bij het daadwerkelijk verzenden van het request onder water de
    URL-encodingregels toegepast worden, dus een spatie wordt verzonden als
    een plusteken.

    `q="Sint Jacob" Utre`: geeft o.a. adressen terug waarvan er delen
    achtereenvolgens beginnen met "Sint" en "Jacob", of met "St"
    (synoniem) en "Jacob", en waar ook een deel met "Utre" begint. Een
    voorbeeld is het adres St.-Jacobsstraat 200 (officiële schrijfwijze)
    in Utrecht.
     * @param lat (optional) Hiermee kan een coördinaat (in lat/lon, ofwel WGS84) worden opgegeven. Met
    behulp van deze parameters worden de gevonden zoekresultaten gesorteerd op
    afstand van het meegegeven punt. Wanneer de locatie van de gebruiker bekend
    is, kan op deze manier effectiever worden gezocht.

    Het meegeven van een coördinaat is met name nuttig voor de suggest- en vrije
    geocoder-services. Hier worden meestal meerdere resultaten teruggegeven.
    Als decimaal scheidingsteken moet een punt worden opgegeven i.p.v. een komma.
     * @param lon (optional) Hiermee kan een coördinaat (in lat/lon, ofwel WGS84) worden opgegeven. Met
    behulp van deze parameters worden de gevonden zoekresultaten gesorteerd op
    afstand van het meegegeven punt. Wanneer de locatie van de gebruiker bekend
    is, kan op deze manier effectiever worden gezocht.

    Het meegeven van een coördinaat is met name nuttig voor de suggest- en vrije
    geocoder-services. Hier worden meestal meerdere resultaten teruggegeven.
    Als decimaal scheidingsteken moet een punt worden opgegeven i.p.v. een komma.

    Voorbeeld: `lat=52.09&lon=5.12`

    De resultaten worden gesorteerd op afstand van een bepaald punt in het
    centrum van Utrecht.
     * @param fl (optional) Hiermee worden de velden opgegeven die teruggegeven dienen te worden.
     * @param fq (optional) Hiermee kan een filter query worden opgegeven, bijv. `fq=bron:BAG`.
     * @param df (optional) Hiermee wordt het default zoekveld opgegeven. Dit is het veld waar standaard
    in gezocht wordt, wanneer de veldnaam niet wordt meegegeven.
     * @param qf (optional) Met behulp van deze parameter kan aan bepaalde _velden_ een extra boost worden
    meegegeven. Hiermee kan de scoreberekening worden aangepast.
     * @param bq (optional) Met behulp van deze parameter kan aan bepaalde _veldwaarden_ een extra
    boost worden meegegeven. Ook hiermee kan de scoreberekening worden aangepast.

    Voor elke boost query moet een aparte `bq=<boost>` worden gebruikt.
    Bijvoorbeeld: `bq=type:gemeente^1.5&bq=type:woonplaats^1.5`.
     * @param start (optional) Hiermee wordt opgegeven wat de index is van het eerste resultaat dat
    teruggegeven wordt. Dit is zero-based. In combinatie met de rows-parameter
    kunnen deze services gepagineerd worden bevraagd. Het maximum is "10.000".
     * @param rows (optional) Hiermee wordt opgegeven wat het maximale aantal rijen (ofwel resultaten) is
    dat teruggegeven moet worden op deze bevraging. Het maximum is "100".
     * @param sort (optional) Hiermee kan worden opgegeven hoe de sortering plaatsvindt.
     * @param wt (optional) Hiermee wordt opgegeven wat het outputformaat is van de bevraging.
     * @return 200 OK
     */
    free(q?: string | undefined, lat?: number | undefined, lon?: number | undefined, fl?: string | undefined, fq?: string[] | undefined, df?: string | undefined, qf?: string | undefined, bq?: string[] | undefined, start?: number | undefined, rows?: number | undefined, sort?: string | undefined, wt?: Wt | undefined): Observable<Anonymous> {
        let url_ = this.baseUrl + "/free?";
        if (q === null)
            throw new Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lon === null)
            throw new Error("The parameter 'lon' cannot be null.");
        else if (lon !== undefined)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        if (fl === null)
            throw new Error("The parameter 'fl' cannot be null.");
        else if (fl !== undefined)
            url_ += "fl=" + encodeURIComponent("" + fl) + "&";
        if (fq === null)
            throw new Error("The parameter 'fq' cannot be null.");
        else if (fq !== undefined)
            fq && fq.forEach(item => { url_ += "fq=" + encodeURIComponent("" + item) + "&"; });
        if (df === null)
            throw new Error("The parameter 'df' cannot be null.");
        else if (df !== undefined)
            url_ += "df=" + encodeURIComponent("" + df) + "&";
        if (qf === null)
            throw new Error("The parameter 'qf' cannot be null.");
        else if (qf !== undefined)
            url_ += "qf=" + encodeURIComponent("" + qf) + "&";
        if (bq === null)
            throw new Error("The parameter 'bq' cannot be null.");
        else if (bq !== undefined)
            bq && bq.forEach(item => { url_ += "bq=" + encodeURIComponent("" + item) + "&"; });
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (rows === null)
            throw new Error("The parameter 'rows' cannot be null.");
        else if (rows !== undefined)
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (wt === null)
            throw new Error("The parameter 'wt' cannot be null.");
        else if (wt !== undefined)
            url_ += "wt=" + encodeURIComponent("" + wt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous>;
        }));
    }

    protected processFree(response: HttpResponseBase): Observable<Anonymous> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous2;
            return throwException("400 Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous>(null as any);
    }

    /**
     * Zodra er op basis van suggesties van de Suggest API een keuze is gemaakt, wordt de
    Lookup API aangeroepen, welke o.a. een (versimpelde) geometrie van de zoekopdracht
    teruggeeft.
     * @param id Hiermee wordt het object-ID opgegeven.
     * @param fl (optional) Hiermee worden de velden opgegeven die teruggegeven dienen te worden.
     * @param fq (optional) Hiermee kan een filter query worden opgegeven, bijv. `fq=bron:BAG`.
     * @param wt (optional) Hiermee wordt opgegeven wat het outputformaat is van de bevraging.
     * @return 200 OK
     */
    lookup(id: string, fl?: string | undefined, fq?: string[] | undefined, wt?: Wt2 | undefined): Observable<Anonymous3> {
        let url_ = this.baseUrl + "/lookup?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (fl === null)
            throw new Error("The parameter 'fl' cannot be null.");
        else if (fl !== undefined)
            url_ += "fl=" + encodeURIComponent("" + fl) + "&";
        if (fq === null)
            throw new Error("The parameter 'fq' cannot be null.");
        else if (fq !== undefined)
            fq && fq.forEach(item => { url_ += "fq=" + encodeURIComponent("" + item) + "&"; });
        if (wt === null)
            throw new Error("The parameter 'wt' cannot be null.");
        else if (wt !== undefined)
            url_ += "wt=" + encodeURIComponent("" + wt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous3>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous3>;
        }));
    }

    protected processLookup(response: HttpResponseBase): Observable<Anonymous3> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous3;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous4;
            return throwException("400 Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous3>(null as any);
    }

    /**
     * De Reverse API biedt de mogelijkheid om een locatie (punt geometrie) op te geven
    om vervolgens verschillende gegevens in een range rondom deze locatie te ontvangen.
     * @param x (optional) Hiermee wordt het coördinaat in X/Y (RD), of in lat/lon (WGS84)
    opgegeven. Vanaf dit coördinaat gaat de reverse geocoder zoeken.
     * @param y (optional) Hiermee wordt het coördinaat in X/Y (RD), of in lat/lon (WGS84)
    opgegeven. Vanaf dit coördinaat gaat de reverse geocoder zoeken.
     * @param lat (optional) Hiermee wordt het coördinaat in X/Y (RD), of in lat/lon (WGS84)
    opgegeven. Vanaf dit coördinaat gaat de reverse geocoder zoeken.
     * @param lon (optional) Hiermee wordt het coördinaat in X/Y (RD), of in lat/lon (WGS84)
    opgegeven. Vanaf dit coördinaat gaat de reverse geocoder zoeken.
     * @param type (optional) Hiermee kan worden opgegeven welke resultaat types je terug krijgt in het
    resultaat. Voor elke type dat je wilt terugkrijgen moet je een aparte type
    parameter toevoegen, bijv. `type=adres&type=gemeente&type=perceel`. Met
    `type=*` krijg je alle types terug. Deze wordt voor het bepalen van de
    resultaten gebruikt en heeft dus geen invloed op aantal resultaten dat
    wordt teruggegeven.
     * @param distance (optional) Hiermee kan een maximale zoekstraal in meters worden opgegeven. Er zullen
    dan geen resultaten worden teruggegeven die verder liggen dan deze waarden.
     * @param fl (optional) Hiermee worden de velden opgegeven die teruggegeven dienen te worden.
     * @param fq (optional) Hiermee kan een filter query worden opgegeven, bijv. `fq=bron:BAG`. Deze wordt
    uitgevoerd nadat de dichtsbijzijnde resultaten zijn gevonden, dus resultaten
    die hier niet aan voldoen worden weggefilterd waardoor je minder resultaten
    dan het aantal rows kan terugkrijgen.
     * @param start (optional) Hiermee wordt opgegeven wat de index is van het eerste resultaat dat
    teruggegeven wordt. Dit is zero-based. In combinatie met de rows-parameter
    kunnen deze services gepagineerd worden bevraagd. Het maximum is "10.000".
     * @param rows (optional) Hiermee wordt opgegeven wat het maximale aantal rijen (ofwel resultaten) is
    dat teruggegeven moet worden op deze bevraging. Het maximum is "100".
     * @param wt (optional) Hiermee wordt opgegeven wat het outputformaat is van de bevraging.
     * @return 200 OK
     */
    reverseGeocoder(x?: number | undefined, y?: number | undefined, lat?: number | undefined, lon?: number | undefined, type?: string | undefined, distance?: number | undefined, fl?: string | undefined, fq?: string | undefined, start?: number | undefined, rows?: number | undefined, wt?: Wt3 | undefined): Observable<Anonymous5> {
        let url_ = this.baseUrl + "/reverse?";
        if (x === null)
            throw new Error("The parameter 'x' cannot be null.");
        else if (x !== undefined)
            url_ += "X=" + encodeURIComponent("" + x) + "&";
        if (y === null)
            throw new Error("The parameter 'y' cannot be null.");
        else if (y !== undefined)
            url_ += "Y=" + encodeURIComponent("" + y) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lon === null)
            throw new Error("The parameter 'lon' cannot be null.");
        else if (lon !== undefined)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (distance === null)
            throw new Error("The parameter 'distance' cannot be null.");
        else if (distance !== undefined)
            url_ += "distance=" + encodeURIComponent("" + distance) + "&";
        if (fl === null)
            throw new Error("The parameter 'fl' cannot be null.");
        else if (fl !== undefined)
            url_ += "fl=" + encodeURIComponent("" + fl) + "&";
        if (fq === null)
            throw new Error("The parameter 'fq' cannot be null.");
        else if (fq !== undefined)
            url_ += "fq=" + encodeURIComponent("" + fq) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (rows === null)
            throw new Error("The parameter 'rows' cannot be null.");
        else if (rows !== undefined)
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        if (wt === null)
            throw new Error("The parameter 'wt' cannot be null.");
        else if (wt !== undefined)
            url_ += "wt=" + encodeURIComponent("" + wt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReverseGeocoder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReverseGeocoder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous5>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous5>;
        }));
    }

    protected processReverseGeocoder(response: HttpResponseBase): Observable<Anonymous5> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous5;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous6;
            return throwException("400 Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous5>(null as any);
    }

    /**
     * De Suggest API biedt de mogelijkheid om een (gedeelte van een) zoekopdracht op
    te voeren, waarnaar er suggesties teruggegeven worden.
     * @param q Hiermee worden de zoektermen opgegeven. De Solr-syntax voor zoektermen kan hier
    worden toegepast, bijv. combineren met "and", en het gebruik van dubbele quotes
    voor opeenvolgende zoektermen. Zoektermen mogen incompleet zijn. Ook wordt er
    gebruik gemaakt van synoniemen.

    Voorbeelden:
    `q=Utrecht`: geeft resultaten terug met de zoekterm Utrecht, bijv. adressen in
    de stad Utrecht, woonplaatsen en gemeenten in de provincie Utrecht.

    `q="De Bilt"`: geeft resultaten terug met de zoekterm De Bilt, bijv. de
    woonplaats en gemeente De Bilt, of adressen in deze woonplaats. Let op
    dat bij het daadwerkelijk verzenden van het request onder water de
    URL-encodingregels toegepast worden, dus een spatie wordt verzonden als
    een plusteken.

    `q="Sint Jacob" Utre`: geeft o.a. adressen terug waarvan er delen
    achtereenvolgens beginnen met "Sint" en "Jacob", of met "St"
    (synoniem) en "Jacob", en waar ook een deel met "Utre" begint. Een
    voorbeeld is het adres St.-Jacobsstraat 200 (officiële schrijfwijze)
    in Utrecht.
     * @param lat (optional) Hiermee kan een coördinaat (in lat/lon, ofwel WGS84) worden opgegeven. Met
    behulp van deze parameters worden de gevonden zoekresultaten gesorteerd op
    afstand van het meegegeven punt. Wanneer de locatie van de gebruiker bekend
    is, kan op deze manier effectiever worden gezocht.

    Het meegeven van een coördinaat is met name nuttig voor de suggest- en vrije
    geocoder-services. Hier worden meestal meerdere resultaten teruggegeven.
    Als decimaal scheidingsteken moet een punt worden opgegeven i.p.v. een komma.

    Voorbeeld: `lat=52.09&lon=5.12`

    De resultaten worden gesorteerd op afstand van een bepaald punt in het
    centrum van Utrecht.
     * @param lon (optional) Hiermee kan een coördinaat (in lat/lon, ofwel WGS84) worden opgegeven. Met
    behulp van deze parameters worden de gevonden zoekresultaten gesorteerd op
    afstand van het meegegeven punt. Wanneer de locatie van de gebruiker bekend
    is, kan op deze manier effectiever worden gezocht.

    Het meegeven van een coördinaat is met name nuttig voor de suggest- en vrije
    geocoder-services. Hier worden meestal meerdere resultaten teruggegeven.
    Als decimaal scheidingsteken moet een punt worden opgegeven i.p.v. een komma.

    Voorbeeld: `lat=52.09&lon=5.12`

    De resultaten worden gesorteerd op afstand van een bepaald punt in het
    centrum van Utrecht.
     * @param fl (optional) Hiermee worden de velden opgegeven die teruggegeven dienen te worden.
     * @param fq (optional) Hiermee kan een filter query worden opgegeven, bijv. `fq=bron:BAG`.
     * @param qf (optional) Met behulp van deze parameter kan aan bepaalde _velden_ een extra boost worden
    meegegeven. Hiermee kan de scoreberekening worden aangepast.
     * @param bq (optional) Met behulp van deze parameter kan aan bepaalde _veldwaarden_ een extra
    boost worden meegegeven. Ook hiermee kan de scoreberekening worden aangepast.

    Voor elke boost query moet een aparte `bq=<boost>` worden gebruikt.
    Bijvoorbeeld: `bq=type:gemeente^1.5&bq=type:woonplaats^1.5`.
     * @param start (optional) Hiermee wordt opgegeven wat de index is van het eerste resultaat dat
    teruggegeven wordt. Dit is zero-based. In combinatie met de rows-parameter
    kunnen deze services gepagineerd worden bevraagd. Hhet maximum is "10.000".
     * @param rows (optional) Hiermee wordt opgegeven wat het maximale aantal rijen (ofwel resultaten) is
    dat teruggegeven moet worden op deze bevraging. Het maximum is "100".
     * @param sort (optional) Hiermee kan worden opgegeven hoe de sortering plaatsvindt.
     * @param wt (optional) Hiermee wordt opgegeven wat het outputformaat is van de bevraging.
     * @return 200 OK
     */
    suggest(q: string, lat?: number | undefined, lon?: number | undefined, fl?: string | undefined, fq?: string[] | undefined, qf?: string | undefined, bq?: string[] | undefined, start?: number | undefined, rows?: number | undefined, sort?: string | undefined, wt?: Wt4 | undefined): Observable<Anonymous7> {
        let url_ = this.baseUrl + "/suggest?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lon === null)
            throw new Error("The parameter 'lon' cannot be null.");
        else if (lon !== undefined)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        if (fl === null)
            throw new Error("The parameter 'fl' cannot be null.");
        else if (fl !== undefined)
            url_ += "fl=" + encodeURIComponent("" + fl) + "&";
        if (fq === null)
            throw new Error("The parameter 'fq' cannot be null.");
        else if (fq !== undefined)
            fq && fq.forEach(item => { url_ += "fq=" + encodeURIComponent("" + item) + "&"; });
        if (qf === null)
            throw new Error("The parameter 'qf' cannot be null.");
        else if (qf !== undefined)
            url_ += "qf=" + encodeURIComponent("" + qf) + "&";
        if (bq === null)
            throw new Error("The parameter 'bq' cannot be null.");
        else if (bq !== undefined)
            bq && bq.forEach(item => { url_ += "bq=" + encodeURIComponent("" + item) + "&"; });
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (rows === null)
            throw new Error("The parameter 'rows' cannot be null.");
        else if (rows !== undefined)
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (wt === null)
            throw new Error("The parameter 'wt' cannot be null.");
        else if (wt !== undefined)
            url_ += "wt=" + encodeURIComponent("" + wt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuggest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuggest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous7>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous7>;
        }));
    }

    protected processSuggest(response: HttpResponseBase): Observable<Anonymous7> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous7;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous8;
            return throwException("400 Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous7>(null as any);
    }
}

export interface ErrorDto {
    code?: number;
    metadata?: string[];
    msg?: string;
}

export interface Highlighting {

    [key: string]: Anonymous9 | any;
}

export interface Response {
    docs?: any[];
    maxScore?: number;
    numFound?: number;
    numFoundExact?: boolean;
    start?: number;
}

export interface Spellcheck {
    collations?: string[];
    suggestions?: string[];
}

export enum Wt {
    Json = "json",
    Xml = "xml",
}

export enum Wt2 {
    Json = "json",
    Xml = "xml",
}

export enum Wt3 {
    Json = "json",
    Xml = "xml",
}

export enum Wt4 {
    Json = "json",
    Xml = "xml",
}

export interface Anonymous {
    response?: Response;
}

export interface Anonymous2 {
    error?: ErrorDto;
}

export interface Anonymous3 {
    response?: Response;
}

export interface Anonymous4 {
    error?: ErrorDto;
}

export interface Anonymous5 {
    response?: Response;
}

export interface Anonymous6 {
    error?: ErrorDto;
}

export interface Anonymous7 {
    highlighting?: Highlighting;
    response?: Response;
    spellcheck?: Spellcheck;
}

export interface Anonymous8 {
    error?: ErrorDto;
}

export interface Anonymous9 {
    suggest?: string[];
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}